import { GroupsScreen } from 'app/features/group/screens'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

import { GroupNavCarousel } from 'app/features/group/components'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { fetchSuggestedGroupsQuery } from 'app/features/group/screens/groups-screen/queries'
import { userGroupJoinRequestsQuery, userGroupsQuery } from 'app/features/group/queries'

export default function Page() {
  return <GroupsScreen HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user
  const client = initializeApollo({ token: user?.token })

  if (user) {
    await client.query({
      query: userGroupsQuery.query,
      variables: {
        ...userGroupsQuery.defaultVariables,
      },
    })

    await client.query({
      query: userGroupJoinRequestsQuery.query,
      variables: {
        ...userGroupJoinRequestsQuery.defaultVariables,
      },
    })

    await client.query({
      query: fetchSuggestedGroupsQuery,
      variables: {
        limit: 10,
      },
    })
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
